import React from 'react'

export default function Footer() {
  return (
    <div>
      <style>
        {`
          .footer a {
            transition: color 0.3s ease;
          }
          .footer a:hover {
            color: #FFBC1E !important;
          }
          @media (max-width: 780.98px) {
  .footer.wow {
    opacity: 1 !important;
    visibility: visible !important;
    animation: none !important;
    transform: none !important;
  }
  
  /* Also disable WOW animations entirely on mobile if issues persist */
  .wow {
    visibility: visible !important;
    animation-delay: 0s !important;
    animation-name: none !important;
  }
}

        `}
      </style>
           {/* Footer Start */}
  <div className="container-fluid text-light footer pt-5 wow fadeIn" 
     data-wow-delay="0.1s"
     style={{
       position: 'relative',
       zIndex: 10,
       marginTop: 0,
       opacity: 1,
       visibility: 'visible',
       backgroundColor: '#001437', // Dark blue as in the picture
       fontFamily: "'Inter', sans-serif"
     }}>

      <div className="container py-5 px-lg-5">
        <div className="row g-5 text-center text-lg-start">
          <div className="col-lg-4 col-md-6 mb-5 d-flex flex-column align-items-center align-items-lg-start">
            <img src="assets/img/logo3.png" alt="Aviator Travel Service" style={{ maxWidth: '250px' }} />
            <p className="mt-4 mb-3">Suivez-nous</p>
            <div className="d-flex pt-2 justify-content-center justify-content-lg-start">
              <a className="btn btn-outline-light btn-social rounded-circle me-2" href="https://www.facebook.com/AVIATORTN" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f" /></a>
              <a className="btn btn-outline-light btn-social rounded-circle" href="https://www.instagram.com/aviator_travel_services/?hl=fr" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram" /></a>
            </div>
          </div>
          
          <div className="col-lg-4 col-md-6 mb-5">
            <h4 className="text-white mb-4 fw-bold">Contact</h4>
            <div className="d-flex mb-3 justify-content-center justify-content-lg-start">
              <i className="fa fa-map-marker-alt me-3 mt-1" />
              <span>Agence Ennasr: 32, Avenue Hédi Nouira - Résidence Abou Kacem Chebbi Bureau A2- Ennasr 2, Ariana Tunis, Ariana, Tunisia</span>
            </div>
            <p className="mb-3">
              <i className="fa fa-phone-alt me-3" />
              +216 29 308 000
            </p>
            <p className="mb-3">
              <i className="fa fa-envelope me-3" />
              booking@aviatortravel.tn
            </p>
          </div>
          
          <div className="col-lg-4 col-md-6 mb-5 ps-lg-5">
            <div className="d-flex flex-column justify-content-start align-items-center align-items-lg-start">
              <a className="text-light mb-2 text-decoration-none" href="/"><i className="fa fa-angle-right me-2 fw-bold" />Accueil</a>
              <a className="text-light mb-2 text-decoration-none" href="/services"><i className="fa fa-angle-right me-2 fw-bold" />Nos services</a>
              <a className="text-light mb-2 text-decoration-none" href="/billets"><i className="fa fa-angle-right me-2 fw-bold" />Billets d'avion</a>
              <a className="text-light mb-2 text-decoration-none" href="/hotelstn"><i className="fa fa-angle-right me-2 fw-bold" />Hôtels en Tunisie</a>
              <a className="text-light mb-2 text-decoration-none" href="/voyage"><i className="fa fa-angle-right me-2 fw-bold" />Voyages</a>
              <a className="text-light mb-2 text-decoration-none" href="/sport"><i className="fa fa-angle-right me-2 fw-bold" />Sports</a>
              <a className="text-light mb-2 text-decoration-none" href="/omra"><i className="fa fa-angle-right me-2 fw-bold" />Omra</a>
              <a className="text-light text-decoration-none" href="/contact"><i className="fa fa-angle-right me-2 fw-bold" />Contact</a>
            </div>
          </div>
        </div>
      </div>
      
      <div className="container px-lg-5">
        <div className="border-top py-4" style={{ borderColor: 'rgba(256, 256, 256, .1)' }}>
          <div className="row align-items-center text-center text-lg-start">
            <div className="col-lg-6 mb-3 mb-lg-0" style={{ fontSize: '0.9rem' }}>
              © aviatortravel.tn, tous droits réservés.
            </div>
            <div className="col-lg-6 text-lg-end" style={{ fontSize: '0.9rem' }}>
              <a href="/" className="text-light text-decoration-none">Accueil</a>
              <span className="mx-2 text-light">|</span>
              <a href="/login" className="text-light text-decoration-none">Espace Professionnel</a>
              <span className="mx-2 text-light">|</span>
              <a href="/contact" className="text-light text-decoration-none">Contactez nous</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Footer End */}
    </div>
  )
}
